import { SelectSearchOption } from '../../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { Typeoftreatment } from '../../../mdqx-graphql-types';

export class TypeOfTreatmentEntity implements SelectSearchOption<TypeOfTreatmentEntity> {
    constructor(public Id: number, public Name: string) {}
    get optionLabel() {
        return this.Name;
    }
    static readonly GqlFields: Array<keyof Typeoftreatment> = ['id', 'name'];
    static fromBackend(res: Typeoftreatment) {
        return new TypeOfTreatmentEntity(res.id, res.name);
    }
}
